module.exports = __webpack_public_path__ + "img/trip.85ea72dc.jpg";